export default __webpack_public_path__ + "static/media/LogoLaPolar.954564a3.svg";